/** Genera el Excel SBS mensual con valores calculados (sin fórmulas). */

/** Fila 1-based en plantilla → clave en metrics */
export const SBS_ROW_KEYS = {
  7: 'usdRate',
  8: 'workDays',
  9: 'hoursPerDay',
  12: 'advisorsCount',
  14: 'mechanicsCount',
  15: 'electriciansCount',
  16: 'bodyworkCount',
  17: 'paintersCount',
  18: 'totalProductiveStaff',
  20: 'serviceChiefCount',
  21: 'foremanCount',
  22: 'bodyworkSupervisorCount',
  23: 'totalLeadershipStaff',
  25: 'officeStaffCount',
  26: 'partsChiefCount',
  27: 'partsStaffCount',
  28: 'otherWorkshopStaffCount',
  29: 'totalWorkshopStaff',
  32: 'vwWorkBaysCount',
  33: 'bodyworkBaysCount',
  34: 'paintBaysCount',
  35: 'alignmentBaysCount',
  36: 'paintBoothsCount',
  37: 'totalWorkBays',
  39: 'hoursToWorkMonth',
  41: 'presenceHours',
  44: 'productiveHoursVw',
  45: 'productiveHoursAmarok',
  46: 'totalProductiveHours',
  48: 'soldHoursVw',
  49: 'soldHoursAmarok',
  50: 'totalSoldHours',
  52: 'stepsVw',
  53: 'stepsAmarok',
  54: 'totalSteps',
  57: 'maintenanceVw',
  58: 'maintenanceAmarokTsi',
  59: 'maintenanceAmarokTdi',
  60: 'totalMaintenance',
  61: 'segmentServices',
  64: 'hoursPerStepOccupied',
  65: 'hoursPerStepBilled',
  66: 'occupationPct',
  67: 'billingPct',
  70: 'laborSalesVw',
  71: 'laborSalesAmarok',
  72: 'totalLaborSales',
  74: 'laborPriceUsd',
  76: 'partsSalesVw',
  77: 'partsSalesAmarok',
  78: 'totalPartsSales',
  79: 'partsPurchaseAmount',
  81: 'laborPerStep',
  82: 'partsPerStep',
  83: 'lubricantConsumption',
  84: 'lubricantConsumption',
  85: 'calculatedSoldHours',
  86: 'soldHoursDifference',
  87: 'maintenancePct',
  89: 'serviceWaitDays',
};

const SBS_LABELS = {
  1: 'VOLKSWAGEN  Group Latin America Inc.',
  2: 'Reporte Mensual de Servicios',
  7: 'U$S Promedio Mensual del Dólar',
  8: 'Dias Laborales al Mes',
  9: 'Horas Laborales por dia',
  11: 'PERSONAL EXCLUSIVO VW',
  12: 'No. de Asesores de Servicio',
  14: 'Mecánicos  (mecatrónicos / alineadores / etc.)',
  15: 'Electricistas',
  16: 'Chapistas',
  17: 'Pintores y preparadores',
  18: 'TOTAL DE PERSONAL PRODUCTIVO',
  20: 'Jefe de Servicio (Jefe de Taller)',
  21: 'Capataz',
  22: 'Capataz o Supervisor de Chapa & Pintura',
  23: 'TOTAL DE PERSONAL DE JEFATURA',
  25: 'Personal de oficina',
  26: 'Jefe de Repuestos',
  27: 'Personal de repuestos',
  28: 'Otro personal de taller (pañol, lavado)',
  29: 'TOTAL DE PERSONAL DEL TALLER',
  31: 'CAPACIDAD',
  32: 'No. de Puestos de trabajo VW (sin C&P)',
  33: 'No. de puestos para trabajos de Chapa',
  34: 'No. de puestos de trabajo Pintura',
  35: 'No. de puestos de alineación / balanceo',
  36: 'No. de cabinas de pintura',
  37: 'TOTAL DE PUESTOS DE TRABAJO',
  39: 'Horas a trabajar al mes por personal VW',
  41: 'Horas Presencia del Personal Productivo (VW+Amarok+Saveiro)',
  43: 'UTILIZACION DE CAPACIDAD',
  44: 'Horas trabajadas en VW autos',
  45: 'Horas trabajadas en Amarok',
  46: 'TOTAL HORAS PRODUCTIVAS',
  48: 'Horas vendidas VW autos',
  49: 'Horas vendidas AMAROK',
  50: 'TOTAL HORAS VENDIDAS',
  52: 'No. de pasos por Taller  VW',
  53: 'No. De Pasos por Taller AMAROK',
  54: 'TOTAL DE PASOS DE TALLER',
  56: 'SERVICIOS DE INSPECCIÓN Y MANTENIMIENTO',
  57: 'Servicios de Mantenimiento - VW Pasajeros',
  58: 'Servicios de Mantenimiento - AMAROK TSI',
  59: 'Servicios de Mantenimiento - AMAROK TDI / V6',
  60: 'TOTAL DE SERVICIOS',
  61: 'Servicios Segmento II y III',
  63: 'PARAMETROS DE CONTROL',
  64: 'Horas Ocupadas por Paso de taller',
  65: 'Horas Facturadas por Paso de taller',
  66: '% Ocupación',
  67: '% Facturación',
  69: 'NEGOCIO',
  70: 'Venta de mano de obra VW Autos',
  71: 'Ventas de Mano de Obra AMAROK',
  72: 'TOTAL VENTA MANO DE OBRA ($U)',
  74: 'Precio de Mano de Obra - SIN IVA (por hora en $U)',
  76: 'Ventas de Repuestos VW Autos',
  77: 'Ventas de Repuestos AMAROK',
  78: 'TOTAL VENTA DE REPUESTOS ($U)',
  79: 'Compra de repuestos',
  80: 'PARAMETROS DE CONTROL',
  81: 'Venta Mano Obra / paso de taller',
  82: 'Venta de repuestos / paso de taller',
  83: 'Consumo de Lubricante a utilizar (promedio)',
  84: 'Consumo de Lubricante a utilizar (promedio)',
  85: 'HORAS VENDIDAS - CALCULADO (VTA. M.O. / PRECIO M.O.)',
  86: 'Diferencia con horas vendidas informadas (fila 52)',
  87: '% SERVICIOS MANTENIMIENTO',
  89: 'DIAS DE ESPERA PARA SERVICIO',
};

/** Orden de filas como en la planilla Excel */
export const SBS_PREVIEW_ROW_ORDER = [
  7, 8, 9,
  11, 12, 14, 15, 16, 17, 18,
  20, 21, 22, 23,
  25, 26, 27, 28, 29,
  31, 32, 33, 34, 35, 36, 37,
  39, 41,
  43, 44, 45, 46,
  48, 49, 50,
  52, 53, 54,
  56, 57, 58, 59, 60, 61,
  63, 64, 65, 66, 67,
  69, 70, 71, 72,
  74,
  76, 77, 78, 79,
  80, 81, 82, 83, 84, 85, 86, 87,
  89,
];

export const SERVICE_MODEL_COLUMNS = [
  'S1', 'S2', 'S3', 'S4', 'S5', 'S6',
  'S7', 'S8', 'S9', 'S10', 'S11', 'S12', 'total',
];

export function cloneServiceByModel(rows = []) {
  return rows.map((row) => ({ ...row }));
}

const round2 = (value) => Math.round(Number(value) * 100) / 100;

export function rebuildServiceByModel(templateRows = [], lines = []) {
  const rows = templateRows.map((row) => {
    const next = { model: row.model };
    SERVICE_MODEL_COLUMNS.forEach((col) => {
      next[col] = 0;
    });
    return next;
  });

  lines.forEach((line) => {
    if (!line?.serviceCode || !line?.modelLabel) return;
    let row = rows.find((item) => item.model === line.modelLabel);
    if (!row) {
      row = { model: line.modelLabel };
      SERVICE_MODEL_COLUMNS.forEach((col) => {
        row[col] = 0;
      });
      rows.push(row);
    }
    if (!Object.prototype.hasOwnProperty.call(row, line.serviceCode)) return;
    row[line.serviceCode] = (Number(row[line.serviceCode]) || 0) + 1;
    row.total = SERVICE_MODEL_COLUMNS.filter((col) => col !== 'total').reduce(
      (acc, col) => acc + (Number(row[col]) || 0),
      0,
    );
  });

  return rows;
}

export function rebuildSbsMetrics(metrics = {}, lines = []) {
  const bucket = {
    productiveHoursVw: 0,
    productiveHoursAmarok: 0,
    soldHoursVw: 0,
    soldHoursAmarok: 0,
    stepsVw: 0,
    stepsAmarok: 0,
    laborSalesVw: 0,
    laborSalesAmarok: 0,
    partsSalesVw: 0,
    partsSalesAmarok: 0,
    maintenanceVw: 0,
    maintenanceAmarokTsi: 0,
    maintenanceAmarokTdi: 0,
  };

  lines.forEach((line) => {
    const amarok = line.group === 'amarok' || line.group === 'amarok_tsi';
    if (amarok) {
      bucket.productiveHoursAmarok += Number(line.productiveHours) || 0;
      bucket.soldHoursAmarok += Number(line.soldHours) || 0;
      bucket.stepsAmarok += 1;
      bucket.laborSalesAmarok += Number(line.laborSales) || 0;
      bucket.partsSalesAmarok += Number(line.partsSales) || 0;
    } else {
      bucket.productiveHoursVw += Number(line.productiveHours) || 0;
      bucket.soldHoursVw += Number(line.soldHours) || 0;
      bucket.stepsVw += 1;
      bucket.laborSalesVw += Number(line.laborSales) || 0;
      bucket.partsSalesVw += Number(line.partsSales) || 0;
    }
    if (line.isMaintenance) {
      if (line.group === 'amarok_tsi') bucket.maintenanceAmarokTsi += 1;
      else if (line.group === 'amarok') bucket.maintenanceAmarokTdi += 1;
      else bucket.maintenanceVw += 1;
    }
  });

  const hoursPerDay = Number(metrics.hoursPerDay) || 0;
  const mechanicsCount = Number(metrics.mechanicsCount) || 0;
  const totalProductiveStaff = Number(metrics.totalProductiveStaff) || 0;
  const workDays = Number(metrics.workDays) || 0;
  const hoursToWorkMonth = hoursPerDay * mechanicsCount * workDays;
  const presenceHours = hoursPerDay * totalProductiveStaff * workDays;
  const totalProductiveHours =
    bucket.productiveHoursVw + bucket.productiveHoursAmarok;
  const totalSoldHours = bucket.soldHoursVw + bucket.soldHoursAmarok;
  const totalSteps = bucket.stepsVw + bucket.stepsAmarok;
  const totalMaintenance =
    bucket.maintenanceVw +
    bucket.maintenanceAmarokTsi +
    bucket.maintenanceAmarokTdi;
  const totalLaborSales = bucket.laborSalesVw + bucket.laborSalesAmarok;
  const totalPartsSales = bucket.partsSalesVw + bucket.partsSalesAmarok;
  const laborPriceUsd = Number(metrics.laborPriceUsd) || 0;
  const hoursPerStepOccupied =
    totalSteps > 0 ? totalProductiveHours / totalSteps : 0;
  const hoursPerStepBilled = totalSteps > 0 ? totalSoldHours / totalSteps : 0;
  const occupationPct =
    presenceHours > 0 ? (totalProductiveHours / presenceHours) * 100 : 0;
  const billingPct =
    totalProductiveHours > 0
      ? (totalSoldHours / totalProductiveHours) * 100
      : 0;
  const laborPerStep = totalSteps > 0 ? totalLaborSales / totalSteps : 0;
  const partsPerStep = totalSteps > 0 ? totalPartsSales / totalSteps : 0;
  const calculatedSoldHours =
    laborPriceUsd > 0 ? totalLaborSales / laborPriceUsd : 0;

  return {
    ...metrics,
    hoursToWorkMonth: round2(hoursToWorkMonth),
    presenceHours: round2(presenceHours),
    productiveHoursVw: round2(bucket.productiveHoursVw),
    productiveHoursAmarok: round2(bucket.productiveHoursAmarok),
    totalProductiveHours: round2(totalProductiveHours),
    soldHoursVw: round2(bucket.soldHoursVw),
    soldHoursAmarok: round2(bucket.soldHoursAmarok),
    totalSoldHours: round2(totalSoldHours),
    stepsVw: bucket.stepsVw,
    stepsAmarok: bucket.stepsAmarok,
    totalSteps,
    maintenanceVw: bucket.maintenanceVw,
    maintenanceAmarokTsi: bucket.maintenanceAmarokTsi,
    maintenanceAmarokTdi: bucket.maintenanceAmarokTdi,
    totalMaintenance,
    hoursPerStepOccupied: round2(hoursPerStepOccupied),
    hoursPerStepBilled: round2(hoursPerStepBilled),
    occupationPct: round2(occupationPct),
    billingPct: round2(billingPct),
    laborSalesVw: round2(bucket.laborSalesVw),
    laborSalesAmarok: round2(bucket.laborSalesAmarok),
    totalLaborSales: round2(totalLaborSales),
    partsSalesVw: round2(bucket.partsSalesVw),
    partsSalesAmarok: round2(bucket.partsSalesAmarok),
    totalPartsSales: round2(totalPartsSales),
    laborPerStep: round2(laborPerStep),
    partsPerStep: round2(partsPerStep),
    calculatedSoldHours: round2(calculatedSoldHours),
    soldHoursDifference: round2(totalSoldHours - calculatedSoldHours),
    maintenancePct: round2(
      totalSteps > 0 ? (totalMaintenance / totalSteps) * 100 : 0,
    ),
  };
}

export function buildSbsPreviewRows(metrics = {}) {
  return SBS_PREVIEW_ROW_ORDER.map((rowNum) => {
    const label = SBS_LABELS[rowNum];
    const key = SBS_ROW_KEYS[rowNum];
    if (key) {
      return {
        id: `row-${rowNum}`,
        rowNum,
        type: 'data',
        label,
        key,
        value: metrics[key] ?? '',
      };
    }
    return {
      id: `row-${rowNum}`,
      rowNum,
      type: 'section',
      label,
    };
  });
}

export function parsePreviewValue(raw) {
  if (raw === '' || raw == null) return null;
  const normalized = String(raw).trim().replace(',', '.');
  if (normalized === '') return null;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}

export function formatPreviewValue(value) {
  if (value == null || value === '') return '—';
  return String(value);
}

const GRAY_TOTAL_ROWS = new Set([
  18, 23, 29, 37, 39, 46, 50, 54, 64, 65, 66, 67, 72, 78, 81, 82, 87,
]);
const LIGHT_GRAY_ROWS = new Set([60, 83, 84, 85, 86]);
const HEADER_ROWS = new Set([1, 2]);

const COLORS = {
  header: 'FFFFCC',
  gray: 'C0C0C0',
  lightGray: 'BFBFBF',
  modelHeader: '000000',
  modelHeaderText: 'FFFFFF',
  serviceHeader: '92D050',
  modelLabel: '9DC3E6',
};

const thinBorder = {
  top: { style: 'thin', color: { rgb: '000000' } },
  bottom: { style: 'thin', color: { rgb: '000000' } },
  left: { style: 'thin', color: { rgb: '000000' } },
  right: { style: 'thin', color: { rgb: '000000' } },
};

function getRowFill(rowNum) {
  if (GRAY_TOTAL_ROWS.has(rowNum)) return COLORS.gray;
  if (LIGHT_GRAY_ROWS.has(rowNum)) return COLORS.lightGray;
  if (HEADER_ROWS.has(rowNum)) return COLORS.header;
  return null;
}

function solidFill(rgb) {
  return { patternType: 'solid', fgColor: { rgb } };
}

function baseStyle({ bold = false, fill = null, align = 'left' } = {}) {
  const style = {
    font: { name: 'Calibri', sz: 10, bold },
    alignment: { vertical: 'center', horizontal: align, wrapText: true },
    border: thinBorder,
  };
  if (fill) style.fill = solidFill(fill);
  return style;
}

function cell(value, style) {
  if (value == null || value === '') {
    return { v: '', t: 's', s: style };
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return { v: value, t: 'n', s: style };
  }
  const n = Number(String(value).replace(',', '.'));
  if (typeof value !== 'string' && Number.isFinite(n)) {
    return { v: n, t: 'n', s: style };
  }
  if (typeof value === 'string' && value.trim() !== '' && Number.isFinite(n) && /^-?\d+([.,]\d+)?$/.test(value.trim())) {
    return { v: n, t: 'n', s: style };
  }
  return { v: String(value), t: 's', s: style };
}

function labelCell(rowNum, text) {
  const fill = getRowFill(rowNum);
  return cell(text, baseStyle({ bold: true, fill, align: 'left' }));
}

function valueCell(rowNum, value) {
  const fill = getRowFill(rowNum);
  return cell(value ?? '', baseStyle({ bold: false, fill, align: 'right' }));
}

function buildStyledSbsSheet(metrics = {}, monthLabel = '', omittedRowNums = []) {
  const omitted = new Set(omittedRowNums.map(Number));
  const rowNums = Object.keys(SBS_LABELS)
    .map(Number)
    .sort((a, b) => a - b);
  const grid = [];

  rowNums.forEach((rowNum) => {
    if (omitted.has(rowNum)) return;
    const key = SBS_ROW_KEYS[rowNum];
    const label = SBS_LABELS[rowNum];
    const value = key ? metrics[key] : rowNum === 2 ? monthLabel : '';
    grid.push([
      labelCell(rowNum, label),
      key || rowNum === 2 ? valueCell(rowNum, value) : cell('', baseStyle()),
    ]);
  });

  return grid;
}

const MODEL_EXCEL_COLUMNS = [
  'S1', 'S2', 'S3', 'S4', 'S5', 'S6',
  'S7', 'S8', 'S9', 'S10', 'S11', 'S12',
];

function buildStyledModelSheet(serviceByModel = []) {
  const headerRow = [
    cell('MODELO', baseStyle({
      bold: true,
      fill: COLORS.modelHeader,
      align: 'center',
    })),
    ...MODEL_EXCEL_COLUMNS.map((code) =>
      cell(code, baseStyle({
        bold: true,
        fill: COLORS.serviceHeader,
        align: 'center',
      })),
    ),
  ];
  headerRow[0].s.font.color = { rgb: COLORS.modelHeaderText };

  const rows = [headerRow];
  serviceByModel.forEach((item) => {
    rows.push([
      cell(item.model, baseStyle({ bold: true, fill: COLORS.modelLabel, align: 'left' })),
      ...MODEL_EXCEL_COLUMNS.map((code) =>
        valueCell(0, item[code] ?? 0),
      ),
    ]);
  });
  return rows;
}

function applySheetLayout(ws, { colWidths, rowCount, colCount }) {
  ws['!cols'] = colWidths;
  ws['!rows'] = Array.from({ length: rowCount }, () => ({ hpt: 15 }));
  ws['!ref'] = `A1:${String.fromCharCode(64 + colCount)}${rowCount}`;
}

export function buildSbsWorkbookSheets(payload) {
  const { metrics = {}, label, serviceByModel = [], omittedSbsRowNums = [] } = payload || {};
  const monthLabel = label || metrics.label || '';
  const sbs = buildStyledSbsSheet(metrics, monthLabel, omittedSbsRowNums);
  const serviceByModelSheet = buildStyledModelSheet(serviceByModel);
  return { sbs, serviceByModel: serviceByModelSheet };
}

export function downloadSbsExcel(payload, year, month) {
  // eslint-disable-next-line global-require
  const XLSX = require('xlsx-js-style');
  const { sbs, serviceByModel } = buildSbsWorkbookSheets(payload);

  const wsSbs = XLSX.utils.aoa_to_sheet(sbs);
  applySheetLayout(wsSbs, {
    colWidths: [{ wch: 52 }, { wch: 11 }, ...Array(12).fill({ wch: 10 })],
    rowCount: Math.max(sbs.length, 1),
    colCount: 14,
  });

  const wsModel = XLSX.utils.aoa_to_sheet(serviceByModel);
  applySheetLayout(wsModel, {
    colWidths: [{ wch: 22 }, ...MODEL_EXCEL_COLUMNS.map(() => ({ wch: 6 }))],
    rowCount: serviceByModel.length,
    colCount: 1 + MODEL_EXCEL_COLUMNS.length,
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, wsSbs, 'SBS');
  XLSX.utils.book_append_sheet(wb, wsModel, 'Servicio x Modelo');

  const monthPad = String(month).padStart(2, '0');
  const fileLabel = payload?.label || monthPad;
  XLSX.writeFile(wb, `SBS_${year}_${monthPad}_${fileLabel}.xlsx`);
}
